var _style, _defs, _g, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiechtenstein = function SvgLiechtenstein(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Liechtenstein_svg__E{stroke:#010101}.Liechtenstein_svg__F{stroke-linejoin:round}.Liechtenstein_svg__G{stroke-width:.1}.Liechtenstein_svg__H{fill:#fed500}.Liechtenstein_svg__I{stroke-linecap:round}.Liechtenstein_svg__J{fill:#010101}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Liechtenstein_svg__A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -119.5,
    cy: 98.7,
    r: 96.4,
    fill: "none",
    transform: "rotate(315 -119 99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Liechtenstein_svg__B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.4,
    cy: 99.8,
    r: 97.5,
    fill: "none",
    transform: "rotate(279 99 100)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Liechtenstein_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-264 2H25v193h-289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed2224",
    d: "M-264 2H25v65h-289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a3e98",
    d: "M-264 131H25v64h-289z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.4,
    cy: 99.8,
    r: 97.5,
    fill: "none",
    stroke: "#a5a7aa",
    strokeWidth: 1.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Liechtenstein_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29429b",
    d: "M-10 3h293v195H-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    d: "M-10 100h293v98H-10z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Liechtenstein_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 46v19H38c-2-5-4-9-4-14s3-8 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 47v11m1-12v14m2-15v17m1-17v13m2-13v13m1-14v14m2-14v14m1-14v14m2-14v14m1-13v14m2-14v16m1-15v13m2-13v13",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__I"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 45c3 0 10 4 10 8-1 6-5 4-10 3l-4 1c-1 2-3 3-4 1h-3v9h25V46z",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__J"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Liechtenstein_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56 42 2 1-2 2-1-2zm-3-1 1 2-1 1-2-1zm-3-1 1 2-1 1-2-1zm-4 0 2 1-2 2-1-2zm-3-1 1 2-1 1-2-1zm-4 1 2 1-2 2-1-2zm-3 1 2 1-2 2-1-2zm-2 2 1 1-1 2-2-2zm-2 2 1 2-1 1-2-1zm-1 3 1 2-1 1-2-1zm0 4 1 1-1 2-2-2zm1 3 1 2-1 1-2-1z",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 45v2l-14-2c-5 0-8 1-8 6s2 8 5 12l-3 2c-2-5-4-9-4-14s3-8 9-8z",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 46v19h19c2-5 4-9 4-14s-3-8-8-8l-16 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 47v11m-2-12v14m-1-15v17m-2-17v13m-1-13v13m-2-14v14m-1-14v14m-2-14v14m-1-14v14m-2-13v14m-1-14v16m-2-15v13m-1-14v14",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__I"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72 45c-3 0-10 4-9 8 1 6 5 4 10 3l3 1c2 2 4 3 5 1h2v9H59V46z",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__J"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Liechtenstein_svg__H Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62 42-2 1 2 2 1-2zm3-1-2 2 2 1 1-1zm3-1-1 2 1 1 2-1zm4 0-2 1 2 2 1-2zm3-1-2 2 2 1 1-1zm3 1-1 1 1 2 2-2zm3 1-1 1 1 2 2-2zm3 2-1 1 1 2 2-2zm2 2-2 2 2 1 1-1zm1 3-2 2 2 1 1-1zm0 4-2 1 2 2 1-2zm-1 3-1 2 1 1 2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 45v2l14-2c5 0 8 1 8 6s-2 8-5 12l3 2c2-5 4-9 4-14s-3-8-9-8zm-2-19-2 2 2 3 1-3-1-3zm0 7-2 3 2 3 1-3zm-6-1 3 1 2-1-2-1zm6 0 3 1 2-1-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 31 1 1-1 1-1-1zm0 5 3 3-3 3c-1 1-3-1-3-3s1-3 3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 36v2l-2 1m6 0-2-1v-2m-4 4h6m-6 5c-1 5-1 10-3 14l3-2 2-12zm6 0h-2c0 3 0 8 2 12l3 2c-2-4-3-9-3-14",
    className: "Liechtenstein_svg__I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 56c-4 0-7 2-7 6-1-2-5-7-9-6-2 0-4 3-3 7-2-5-8-6-11-3 3 3 5 11 8 15h44c3-4 5-12 8-15-4-3-9-2-11 3 1-4-1-7-4-7-3-1-7 4-8 6 0-4-3-6-7-6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81 75c0 1-10 3-22 3s-23-2-23-3 11-3 23-3 22 1 22 3Z",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 43 1 1-1 1-1-1zm0 2 1 1-1 1-1-1zm0 2 1 1-1 2-1-2zm0 3 1 1-1 2-2-2zm0 3 1 1-1 2-2-2z",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__H"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 57v2h1v-2zm1 0v2h1v-2zm-2 0v2zm3 0v2h1v-1zm-4 1v1q0 1.5 0 0zm6 0v1q0 1.5 0 0zm-18 0v1h1zm30 0h-1v1q0 1.5 0 0zh-1Zm-29 0 1 1q0 1.5 0 0v-1zm27 0v1q0 1.5 0 0zm-25 0v2zm24 0-1 1v1h1zm-28 0v2l1-1h-1zm31 0v2l1-1zm-19 1-1 1 1 1zm8 0v2zm-4 1h-1v2h-1l-1-1v1c1 2 3 3 3 7 0-4 2-5 3-7v-1l-1 1h-1zm-11-1v1h1v-1zm21 0v1q0 1.5 0 0zm-27 0v1l1 1v-1zm33 0v2l1-1v-1Zm-42 1v1l1 1v-1zm52 0-1 1s0 1 0 0h1zm-51 0v1l1 1v-1zm50 0-1 1v1c-1 0 0 0 0 0l1-1-1-1Zm-53 0v1l1 1v-1c-1-1 0 0 0 0h-1Zm55 1h-1zv-1Zm-32 0v1q0 1.5 0 0zm10 0-1 1h1zm-19-1v4l-1-1 3 6h1v-6l-1-1-1 1zm28 0-2 3-1-1v7l4-6-1 1zm-37 1v1c0 1 0 0 0 0zm46 0-1 1h1zm-41-1v1l1 1s1 0 0 0v-1zm35 0v1l-1 1h1zm-39 2v1h1zm44 0h-1v1h1zm-40 0 1 1c0 1 0 0 0 0zm36 0h-1v1zm-42 1v1l1 2-2-1v1l4 4h1l-1-4v-1q0-1.5 0 0h-1a14 14 0 0 0-2-2m48 0-2 2h-2l1 1-1 4c0 1 0 0 0 0l5-4v-1l-2 1c-1 0 0 0 0 0l1-2z",
    className: "Liechtenstein_svg__J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 73v2m1-2v1m1-2v2m1-2 1 2m1-2v2m1-2 1 2m1-3v2m1-1 1 1m1-2v2m1-2v2m2-2v2m1-2v2m2-2v2m2-2v2m23 0v2m-1-2v1m-1-2-1 2m-1-2v2m-1-2v2m-2-2v2m-1-3v2m-2-1v1m-1-2v2m-2-2v2m-1-2v2m-2-2v2m-1-2v2m-2-2v2m-2-2v2",
    className: "Liechtenstein_svg__E Liechtenstein_svg__F Liechtenstein_svg__G Liechtenstein_svg__H Liechtenstein_svg__I"
  }))));
};
export default SvgLiechtenstein;